import { ResourceManager } from "@/components/admin/ResourceManager";

const SPAN_OPTIONS = [
  { value: "md:col-span-4 md:row-span-1", label: "Kecil" },
  { value: "md:col-span-5 md:row-span-1", label: "Sedang" },
  { value: "md:col-span-7 md:row-span-1", label: "Lebar" },
  { value: "md:col-span-8 md:row-span-2", label: "Besar (lebar + tinggi)" },
];

export const AdminGallery = () => (
  <ResourceManager
    title="Galeri"
    description="Kelola foto pada bento galeri di halaman utama."
    queryKey="gallery"
    endpoint="/gallery"
    columns={[
      {
        key: "url",
        label: "Foto",
        render: (g) => <img src={g.url} alt={g.alt} className="h-12 w-16 rounded-lg object-cover" />,
      },
      { key: "alt", label: "Keterangan" },
      { key: "position", label: "Urutan" },
    ]}
    fields={[
      { name: "url", label: "Foto", type: "image" },
      { name: "alt", label: "Keterangan Foto", type: "text" },
      { name: "span", label: "Ukuran Petak", type: "select", options: SPAN_OPTIONS },
      { name: "position", label: "Urutan Tampil", type: "number" },
    ]}
  />
);
